module.exports = "<svg id=pausa_admin data-name=\"Слой 1\" xmlns=http://www.w3.org/2000/svg viewBox=\"0 0 122 89\"> <defs> <style>.cls-2{fill:#c6c6c6;stroke:#c6c6c6;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px}</style> </defs> <title>Pausa_menu</title> <line class=cls-2 x1=52.15 y1=31.46 x2=52.15 y2=57.46 /> <line class=cls-2 x1=69.15 y1=31.46 x2=69.15 y2=57.46 /> </svg>";


//////////////////
// WEBPACK FOOTER
// ./public/web/images/pausa_admin-01.svg
// module id = 6E35
// module chunks = 3 4